<template>
  <v-app id="inspire">
    <v-container fluid style="height: 100vh; width: 100%; margin-top: 50px">
      <v-container fluid>
        <v-row class="ma-2 my-4 flex">
          <h4 style="margin: auto">Buscar envios</h4>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mx-5">
          <!-- <v-col cols="3" class="">
            <v-select
              :items="sellerNames"
              v-model="filters.chipSeller"
              label="Seller"
            ></v-select>
          </v-col>

          <v-col cols="4">
            <v-text-field
              class="pb-2"
              label="Sponsor"
              v-model="filters.sponsorName"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="">
            <v-text-field
              class="pb-2"
              label="Número da nota"
              v-model="filters.offerExternalId"
            ></v-text-field>
          </v-col> -->
          <v-col cols="3" class="">
            <DateInput
              v-model="filters.createdAtFrom"
              label="Envio de"
            ></DateInput>
          </v-col>
          <v-col cols="3" class="">
            <DateInput
              v-model="filters.createdAtTo"
              label="Envio até"
            ></DateInput>
          </v-col>
          <v-col cols="2" class="">
            <v-btn class="primary" @click="doSearch">Buscar</v-btn>
          </v-col>
        </v-row>
        <v-row class="ma-2 my-4 flex">
          <h4 style="margin: auto">Histórico</h4>
          <v-spacer></v-spacer>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="offers"
          item-key="name"
          class="custom-table"
          :page.sync="page"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :server-items-length.sync="serverItemsLength"
          :footer-props="{
            'items-per-page-options': [10, 25, 50],
          }"
          @update:sort-by="updateSortBy"
          @update:sort-desc="updateSortDesc"
          @update:items-per-page="updateRowsPerPage"
          @update:page="updatePage"
          ref="dataTable"
        >
          <template v-slot:item.createdAt="{ item }">
            <span v-date-format="item.createdAt"></span>
          </template>
          <template v-slot:item.status="{ item }">
            {{ item.kanastraStatus }}
          </template>

          <template v-slot:item.sellerName="{ item }">
            <span>{{ item.seller?.name }}</span>
          </template>

          <template v-slot:item.totalPrice="{ item }">
            <span v-money-format="item.totalPrice"></span>
          </template>
          <template v-slot:item.totalAcquisitionPrice="{ item }">
            <span v-money-format="item.totalAcquisitionPrice"></span>
          </template>

          <template v-slot:item.errorMessage="{ item }">
            <span style="color: red">{{ item.errorMessage }}</span>
          </template>

          <template v-slot:item.error="{ item }">
            <span v-if="item.error" style="color: red">Erro</span>
            <span v-else style="color: green">OK</span>
          </template>

          <template v-slot:item.download="{ item }">
            <v-icon @click="downloadRequest(item.id)"> mdi-download </v-icon>
          </template>
        </v-data-table>
      </v-container>
    </v-container>
  </v-app>
</template>
<script>
import { mapState } from "vuex";
import strapiApi from "../../../../libraries/strapi/strapiApi";
import kanastraApi from "../../../../libraries/kanastra/kanastraApi";
import AutocompleteSelect from "../../components/select/AutocompleteSelect.vue";
import dateFunctions from "../../../../libraries/corsolar/dateFunctions";
import DateInput from "../../components/fields/DateInput.vue";

export default {
  name: "Acquisitions",
  components: {
    AutocompleteSelect,
    DateInput,
  },

  data() {
    return {
      menu: false,
      filters: {
        chipSeller: "",
        offerExternalId: "",
        sponsorName: "",
        createdAtFrom: "",
        createdAtTo: "",
      },
      files: [],
      jsonData: [],
      headers: ["PrestadorRazaoSocial", "DataEmissao"],

      headers: [
        {
          text: "Data de envio",
          align: "start",
          sortable: false,
          value: "createdAt",
        },
        {
          text: "Seller",
          align: "start",
          sortable: false,
          value: "sellerName",
        },
        {
          text: "Preço",
          align: "start",
          sortable: false,
          value: "totalPrice",
        },

        {
          text: "Preço de aquisição",
          align: "start",
          sortable: false,
          value: "totalAcquisitionPrice",
        },
        {
          text: "Status",
          align: "start",
          sortable: false,
          value: "error",
        },
        {
          text: "Erros",
          align: "start",
          sortable: false,
          value: "errorMessage",
        },
        {
          text: "Arquivo",
          align: "start",
          sortable: false,
          value: "download",
        },
      ],

      offers: [],
      sortBy: "id",
      sortDesc: true,
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: 10,
      sellers: [],
    };
  },

  created() {},
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    sellerNames() {
      return this.sellers.map((el) => el.name);
    },
  },

  watch: {},
  async mounted() {
    await this.doSearch();

    await this.getSellers();
  },
  methods: {
    async downloadRequest(acquisitionId) {
      let acquisition = await strapiApi.acquisitions.getById(acquisitionId);

      // Convert the object to JSON string
      const jsonString = JSON.stringify(acquisition, null, 2);

      // Create a Blob from the string
      const blob = new Blob([jsonString], { type: "application/json" });

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Create a link element
      const link = document.createElement("a");
      link.href = url;
      link.download = `acquisition-${acquisition.acquisitionId}.json`; // file name

      // Append to the DOM and trigger download
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    async getSellers() {
      let { values, pagination } = await strapiApi.sellers.getWithPagination(
        this.page,
        this.itemsPerPage,
        this.sortBy,
        this.sortDesc
      );

      this.sellers = values;
    },

    formatDate() {},

    async newPayment() {
      this.$router.push("/newPayment");
    },

    async updatePage() {
      await this.doSearch();
    },

    async updateSortBy() {
      await this.doSearch();
    },

    async updateSortDesc() {
      await this.doSearch();
    },

    async updatePage() {
      await this.doSearch();
    },

    async updateRowsPerPage() {
      await this.doSearch();
    },

    async doSearch() {
      let seller = this.sellers?.find((el) =>
        el.name.includes(this.filters.chipSeller)
      );

      //   sellerId,
      // sponsorName,
      // invoiceNumber,
      // disabled,
      let { values, pagination } =
        await strapiApi.acquisitions.getWithPagination(
          this.page,
          this.itemsPerPage,
          this.sortBy,
          this.sortDesc,
          true,
          seller?.id,
          this.filters.sponsorName,
          this.filters.offerExternalId,
          false,
          this.filters.createdAtFrom,
          this.filters.createdAtTo
        );
      let offers = values;

      //alert(JSON.stringify({ pagination }));
      this.serverItemsLength = pagination?.total;

      this.offers = offers;
    },
  },
};
</script>

<style scoped>
.custom-container {
  background-image: url("~@/assets/img/background.png");
  background-size: cover;
}
</style>
